import { converterDataEua, converterDataHoraBr } from "_utils/Data";
import { utils, writeFileXLSX } from "xlsx";
import { chaveStatusAutorizacao, labelStatus } from "../constants/status";
import { ISolicitacaoPlaca } from "../interfaces/ISolicitacaoPlaca";

export const COLUNAS_EXPORTACAO_SOLICITACOES = [
  "Data e hora da solicitação",
  "PDI",
  "Empresa",
  "Placa",
  "Processo",
  "Status",
];

export function linhasExportacaoSolicitacoes(
  solicitacoes: ISolicitacaoPlaca[]
) {
  return solicitacoes.map((solicitacao) => ({
    "Data e hora da solicitação":
      converterDataHoraBr(solicitacao.dataSolicitacao) ?? "",
    PDI: solicitacao.pdi ?? "",
    Empresa: solicitacao.empresa ?? "",
    Placa: solicitacao.placa,
    Processo: solicitacao.idProcesso ?? "",
    Status: labelStatus(chaveStatusAutorizacao(solicitacao.statusAutorizacao)),
  }));
}

export function exportarSolicitacoesXlsx(
  solicitacoes: ISolicitacaoPlaca[],
  hoje: Date = new Date()
) {
  const planilha = utils.json_to_sheet(
    linhasExportacaoSolicitacoes(solicitacoes),
    {
      header: [...COLUNAS_EXPORTACAO_SOLICITACOES],
    }
  );
  const arquivo = utils.book_new();

  utils.book_append_sheet(arquivo, planilha, "Solicitações");
  writeFileXLSX(arquivo, `solicitacoes_placa_${converterDataEua(hoje)}.xlsx`);
}
